import type {ReactNode} from 'react';

import {useDndContext} from '@dnd-kit/core';

// @ts-expect-error
import {DragHandleIcon} from 'shells/icon/svg/drag-handle-icon';

import styles from './form-sortable-drag-overlay-preview.module.css';

interface Props {
    children: ReactNode;
    fontFamily?: string;
}

export function FormSortableDragOverlayPreview(props: Props) {
    const {activeNodeRect} = useDndContext();

    return (
        <div
            className={styles['row']}
            style={{
                width: activeNodeRect?.width,
                minHeight: activeNodeRect?.height ?? 32,
                fontFamily: props.fontFamily,
            }}
        >
            <div className={styles['handle']}>
                <DragHandleIcon size={14} />
            </div>
            <div className={styles['content']}>{props.children}</div>
        </div>
    );
}
